import { render, staticRenderFns } from "./payChannelData.vue?vue&type=template&id=750865d0&scoped=true"
import script from "./payChannelData.vue?vue&type=script&lang=js"
export * from "./payChannelData.vue?vue&type=script&lang=js"
import style0 from "./payChannelData.vue?vue&type=style&index=0&id=750865d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750865d0",
  null
  
)

export default component.exports